<template>
	<div>
		<el-drawer title="新建关联达人" :visible.sync="dialogVisible" size="700px" :append-to-body="true" closed="handleClose" v-loading="loadingDrawer">
			<el-alert title="达人信息的更新可能会延迟，请耐心等待" type="warning" class="mb-16" show-icon :closable="false" />
			<el-form class="mt-4 form-dr" :model="form" :rules="rules" ref="ruleForm" label-width="82px">
				<div class="dz-info">
					<div class="label fz-16 pl-8 mb-24">团长信息</div>
					<el-form-item label="平台" label-width="100px">
						<div class="flex-row-align-center">
							<div class="i-douyin"></div>
							<span class="yx-color-text-primary ml-4">抖音</span>
						</div>
					</el-form-item>
					<el-form-item label="关联团长" label-width="100px" prop="team_institution_id">
						<el-select
							style="width: 100%"
							v-model="form.team_institution_id"
							:loading-text="loadingText"
							clearable
							:loading="loading"
							filterable
							remote
							:remote-method="remoteMethod"
							@focus="focusFun"
							placeholder="请选择 / 搜索关联团长"
						>
							<el-option v-for="(item, index) in partner_list" :key="index" :label="item.institution_name" :value="item.team_institution_id" />
						</el-select>
					</el-form-item>
					<div class="add-partner mt-8 text-align-right" v-if="true || !onlyZsPartnerTag">
						<span class="add" @click="showPartnerDialog">没找到？去新增团长</span>
					</div>
				</div>
				<div class="basic-info">
					<div class="label fz-16 pl-8 mb-24">基本信息</div>
					<!-- 暂时不用管，视频号和团长无关 -->
					<el-form-item label-width="100px" :label="anchorInfo.label" prop="anchor_account">
						<el-input v-model="form.anchor_account" :placeholder="`请输入${anchorInfo.label}`" maxlength="16" />
						<p class="font-h4-regular yx-color-text-secondary">{{ anchorInfo.tips }}</p>
					</el-form-item>
					<el-form-item label-width="100px" label="达人昵称" prop="anchor_name">
						<el-input v-model="form.anchor_name" placeholder="请输入达人昵称" />
					</el-form-item>
					<el-form-item label-width="100px" label="主页链接">
						<el-input v-model="form.main_url" placeholder="请输入达人主页链接" />
					</el-form-item>
					<el-form-item label-width="100px" label="备注">
						<el-input v-model="form.remark" placeholder="请输入备注" />
					</el-form-item>
				</div>
			</el-form>
			<div class="bott">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit">确认</el-button>
			</div>
		</el-drawer>
		<!-- <partner-dialog ref="partnerDialog" /> -->
		<addCommander-dialog ref="addCommanderDialog"></addCommander-dialog>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
// import partnerDialog from '@/views/channel/components/partnerDialog';
import addCommanderDialog from '@/components/business/addCommanderDialog/addCommanderDialog.vue';
import debounce from 'lodash/debounce';
import { checkDouYin } from '@/utils/validate';
import { addinstitutionAnchor, getInstitutionBaseList } from '@/api/secondColonelManage';
export default {
	name: 'addTalentDrawer',
	components: {
		// partnerDialog,
		addCommanderDialog,
	},
	data() {
		return {
			dialogVisible: false,
			loadingText: '加载中',
			loading: false,
			loadingDrawer: false,
			form: {
				team_institution_id: '',
				anchor_account: '',
				anchor_name: '',
				main_url: '',
				remark: '',
			},
			partner_list: [],
			rules: {
				team_institution_id: { required: true, message: '请选择关联团长', trigger: 'change' },
				anchor_account: [
					// 视频号 暂时可以这样写 视频号没有团长 不会走到这里
					{ required: true, message: `${this.$isDy(this.platformId) ? '请输入抖音号' : '请输入快手号'}`, trigger: 'blur' },
					{ required: true, validator: checkDouYin, trigger: 'blur' },
				],
				anchor_name: { required: true, message: '请输入达人昵称', trigger: 'blur' },
			},
			anchorMap: new Map([
				[+dataMap.PLATFORM_DY.value, { label: '抖音号', tips: '最多16个字，只允许包含字母、数字、下划线和点' }],
				[+dataMap.PLATFORM_KS.value, { label: '快手号', tips: 'ID为纯数字，快手号仅支持8-20个字母、数字、下划线或减号，必须以字母开头' }],
			]),
			anchorInfo: {},
			platformId: '',
		};
	},
	computed: {
		...mapGetters(['onlyZsPartnerTag']),
	},
	methods: {
		// todo wzj ---
		async show(team_institution_id, platformId) {
			this.loadingDrawer = true;
			this.form.team_institution_id = team_institution_id;
			this.platformId = platformId;
			this.anchorInfo = this.anchorMap.get(+platformId);
			await this.remoteMethod();
			this.loadingDrawer = false;
			this.dialogVisible = true;
		},
		handleClose() {
			this.form = {
				team_institution_id: '',
				anchor_account: '',
				anchor_name: '',
				main_url: '',
				remark: '',
			};
			this.partner_list = [];
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		//远程搜索
		async remoteMethod(e = '') {
			this.loading = true;
			this.loadingText = '加载中';
			const { code, data } = await getInstitutionBaseList({ institution_name: e, platform_id: +dataMap.PLATFORM_DY.value });
			this.loading = false;
			if (code == 0) {
				this.partner_list = data.list;
			}
		},
		async focusFun(e) {
			this.loading = true;
			this.loadingText = '加载中';
			const { code, data } = await getInstitutionBaseList({ institution_name: e.target.value, platform_id: +dataMap.PLATFORM_DY.value });
			if (code == 0) {
				this.partner_list = data.list;
				data.list.length ? (this.loading = false) : (this.loadingText = '无数据');
			}
		},
		showPartnerDialog() {
			this.$refs.addCommanderDialog.show(this.platformId);
		},
		submit: debounce(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (!valid) return;
				const { form, platformId: platform_id } = this;
				form.platform_id = platform_id;
				const { code, data } = await addinstitutionAnchor(form);
				if (code !== 0) return;
				this.$message.success('添加成功');
				this.$emit('getDr', form.anchor_account, 1);
				this.$emit('onInject', data);
				this.handleClose();
			});
		}, 1000),
	},
};
</script>

<style lang="less" scoped>
/deep/ .el-drawer__body {
	padding: 16px !important;
	background-color: #f7f8f9;
}
.label {
	position: relative;
	color: @color-gy9;
	font-weight: 500;
}
.label:before {
	content: '';
	width: 3px;
	height: 17px;
	background: @color-b4;
	border-radius: 20px;
	position: absolute;
	left: 0px;
	top: 50%;
	transform: translateY(-50%);
}
.add-partner {
	line-height: 13px;
	font-size: 13px;
	color: #1d2129;
	.add {
		cursor: pointer;
		color: @color-primary;
	}
}
.bott {
	position: absolute;
	bottom: 0;
	left: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	z-index: 2000;
}
.dz-info,
.basic-info {
	border-radius: 8px;
	padding: 20px 16px 16px 16px;
	background: @color-gy1;
	margin-bottom: 16px;
	border-radius: 8px;
}
.form-dr {
	/deep/ .el-form-item__label {
		text-align: left;
	}
}
/deep/ .el-input__inner::-webkit-input-placeholder {
	color: @color-text-placeholder !important;
	font-size: 14px;
}
</style>
